<template>
	<div class="bot-sse-wrapper">
		<transition name="bot-sse-fade">
			<div v-if="showTemporaryMessage" key="bot-temp" class="bot-sse-message bot-sse-message--temp">
				<div class="bot-sse-dots">
					<span v-for="index in 3" :key="index" :style="{ animationDelay: `${(index - 1) * 0.12}s` }" />
				</div>
			</div>
		</transition>
	</div>
</template>

<script setup lang="ts">
import { computed, watch, onUnmounted } from "vue";
import { useAlternisNewStore } from "../../../../store/alternis_new";
import { useVoiceBotStore } from "../../../../store/voiceBot";

const alternisNewStore = useAlternisNewStore();
const voiceBotStore = useVoiceBotStore();

const showTemporaryMessage = computed(
	() =>
		alternisNewStore.voiceBotExists &&
		(voiceBotStore.currentState === "PREPARING" || voiceBotStore.currentState === "FREESTYLE")
);

watch(
	() => alternisNewStore.voiceBotExists,
	(val, oldVal) => {
		if (val && !oldVal) {
			voiceBotStore.initSSE();
		} else if (!val && oldVal) {
			voiceBotStore.closeSSE();
			voiceBotStore.currentState = "STANDBY";
		}
	},
	{ immediate: true }
);

onUnmounted(() => {
	voiceBotStore.closeSSE();
	voiceBotStore.currentState = "STANDBY";
});
</script>

<style scoped lang="scss">
.bot-sse-wrapper {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	padding-left: 62px;
}

.bot-sse-message {
	position: relative;
	padding: 0.65rem 0.95rem;
	border-radius: 20px;
	background: linear-gradient(160deg, rgba(77, 182, 172, 0.14), rgba(79, 195, 247, 0.12));
	border: 1px solid rgba(77, 182, 172, 0.45);
	box-shadow: 0 6px 18px rgba(79, 195, 247, 0.12), inset 0 0 0 1px rgba(149, 117, 205, 0.08);
	color: rgb(var(--v-theme-on-surface));
	font-size: 0.95rem;
	line-height: 1.5;
	backdrop-filter: blur(6px);
}

.bot-sse-message--temp {
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

.bot-sse-dots {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
}

.bot-sse-dots span {
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background: linear-gradient(135deg, #4db6ac, #9575cd);
	animation: bot-sse-bounce 0.9s infinite ease-in-out;
}

@keyframes bot-sse-bounce {
	0%,
	80%,
	100% {
		transform: translateY(0);
		opacity: 0.4;
	}
	40% {
		transform: translateY(-6px);
		opacity: 1;
	}
}

.bot-sse-fade-enter-active,
.bot-sse-fade-leave-active {
	transition: opacity 0.2s ease, transform 0.2s ease;
}

.bot-sse-fade-enter-from,
.bot-sse-fade-leave-to {
	opacity: 0;
	transform: translateY(6px);
}

.bot-sse-list-enter-active,
.bot-sse-list-leave-active {
	transition: all 0.24s ease;
}

.bot-sse-list-enter-from,
.bot-sse-list-leave-to {
	opacity: 0;
	transform: translateY(6px);
}
</style>
